import { memo } from "react";
import { Link } from "react-router-dom";
import { Card, Col, Button } from "antd";
import "./product-card.css";
import noPhoto from "../static/no-photo.webp";
import { API_ENDPOINTS } from "../../constants";
import { formatPrice } from "../../utils/formatPrice";
import { createProductPath } from "../../utils/productUrls";

import { CARD_IMAGE_SIZES, productImageSources } from "../../utils/productImages";
import ProductImage from "../product-image/product-image";

function ProductCard({ id, title, pictId, price }) {
  const imageUrl = pictId > 0 ? API_ENDPOINTS.GET_THUMBNAIL(720, pictId) : noPhoto;

  return (
    <Col className="product__col">
      <Link to={createProductPath(id, title)}>
        <Card
          hoverable
          className="product__card"
          cover={
            <ProductImage
              className="product__img"
              src={imageUrl}
              fallbackSrc={pictId > 0 ? API_ENDPOINTS.GET_FILE(pictId) : undefined}
              alt={title}
              loading="lazy"
              decoding="async"
              width="720"
              height="540"
              srcSet={pictId > 0 ? productImageSources(pictId) : undefined}
              sizes={CARD_IMAGE_SIZES}
            />
          }
        >
          <div>
            <p>{title}</p>
            <p className="product__price">
              {formatPrice(price, {
                withCurrency: true,
                fallback: "Цена по запросу",
              })}
            </p>
          </div>
          <Button className="product__button" type="primary">
            Подробнее
          </Button>
        </Card>
      </Link>
    </Col>
  );
}

export default memo(ProductCard);
